import Shark from './Shark'
import Snapshot from './Snapshot'
import Squiggles from './Squiggles'
export default class World {
  static instance: World

  public snapshot!: Snapshot
  public shark!: Shark
  public squiggles!: Squiggles

  constructor() {
    if (World.instance) {
      return World.instance
    }
    World.instance = this

    this.setSnapshot()
    this.setShark()
    this.setSquiggles()
  }

  setSquiggles() {
    this.squiggles = new Squiggles()
  }

  setSnapshot() {
    this.snapshot = new Snapshot()
  }

  setShark() {
    this.shark = new Shark()
  }

  resize() {}

  update() {
    this.snapshot?.update()
    this.shark?.update()
  }

  destroy() {}
}
